import { Model, Attr } from 'spraypaint'

import ApplicationRecord from '@/models/ApplicationRecord'

@Model()
export default class MultiChoiceGiftCard extends ApplicationRecord {
  static jsonapiType = 'multi_choice_gift_cards'

  @Attr() id!: string
  @Attr() name!: string
  @Attr() createdAt!: string
  @Attr() updatedAt!: string
}
